import { useNotificationsAdapter } from './Notifications.adapter';
import { NotificationsView } from './Notifications.view';

export function Notifications() {
  const { notifications, unreadCount, isLoading, opened, onOpenChange, handleNotificationClick } =
    useNotificationsAdapter();

  return (
    <NotificationsView
      notifications={notifications}
      unreadCount={unreadCount}
      isLoading={isLoading}
      opened={opened}
      onOpenChange={onOpenChange}
      onNotificationClick={handleNotificationClick}
    />
  );
}
